// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___f3323f43ddf415e5974","cls2":"ImpactHubModal-cls2___d695dc3d8bba1b4bbb8 ImpactHubModal-cls1___f3323f43ddf415e5974"};